import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  const currentYear = new Date().getFullYear()

  return (
    <CFooter>
      <div>
        <a href="https://asd.company" target="_blank" rel="noopener noreferrer">
          ASD
        </a>
        {/* <span className="ms-1">&copy; 2024 A-SOLUTIONS DEVELOPMENT.</span> */}
        {/* {` © ${currentYear} A-SOLUTIONS DEVELOPMENT.`} */}
        <span className="ms-1">
          &copy;{' '}{currentYear} A-SOLUTIONS DEVELOPMENT.
        </span>
      </div>
      <div className="ms-auto">
        {/* <span className="me-1">Powered by</span>
        <a href="https://coreui.io/react" target="_blank" rel="noopener noreferrer">
          CoreUI React Admin &amp; Dashboard Template
        </a> */}
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
